export default "__VITE_ASSET__BGh4lYFs__"